<template>
    <v-card style="border-radius: 0px;height: 91.5vh;" color="white" variant="flat">
        <v-col align=center class="" style="font-weight:bold;font-size:25px;background-color: white;">
            Générateur automatique
        </v-col>
        <v-col style="background-color: white;">
            Nombre de génération restante ce mois : {{ groupInformation.article_month_generated_max -
                groupInformation.article_month_generated }} / {{ groupInformation.article_month_generated_max }}
            <!-- {{ groupInformation.article_month_generated }}
            {{ groupInformation.article_month_generated_max}} -->
        </v-col>
        <v-col v-for="platform in platformToShow" :key="platform" class="px-0 pt-0">
            <v-divider></v-divider>
            <div v-for="site in groupInformation.web_site_data[platform]" :key="site.uuid">
                <v-col style="font-weight: bold;font-size: 25px;background-color: white;" align="center">
                    {{ site.label }} <span style="color: grey;font-size: 12px;">( {{ site.web_site }} )</span>
                </v-col>
                <v-col v-if="programationData[site.uuid]" class="">
                    <v-card class="bg pa-2" style="color: white;font-weight: bold;" variant="flat" align="">
                        <!-- <v-text-field
                            :label="'Nombre de programmation automatique mensuel ( maximum de ' + groupInformation.article_month_generated_max + ' programmation )'"
                            type="number" hide-details v-model="programationData[site.uuid]['nbr_progra']" :rules="[
                                v => !v || v <= groupInformation.article_month_generated_max ||
                                    'Le nombre de génération doit être inférieur au nombre de génération mensuel maximum (<' + groupInformation.article_month_generated_max + ')',
                            ]"></v-text-field> -->
                        <div>
                            {{ 'Nombre de programmation automatique mensuel ( maximum de ' +
                                groupInformation.article_month_generated_max + ' programmation )' }}
                        </div>
                        <v-slider color="white"
                            :label="(programationData[site.uuid]['nbr_progra'] == 0 ? '0' : programationData[site.uuid]['nbr_progra']) + ' / ' + groupInformation.article_month_generated_max"
                            step="1" :max="groupInformation.article_month_generated_max" hide-details
                            v-model="programationData[site.uuid]['nbr_progra']"></v-slider>
                    </v-card>
                </v-col>
                <v-divider></v-divider>
                <v-col>
                    <v-card class="pa-2 bg" style="height: 58vh;  overflow: auto;">
                        <div style="width: 100%; min-width: 800px;">
                            <table class="table"
                                style="width: 100%;color:white;   border-collapse: collapse;">
                                <thead>
                                    <tr style="">
                                        <th v-for="(elem, id) in header" style="border: solid 2px white;" class="pa-2"
                                            :key="id"> {{ elem.label }} </th>
                                    </tr>
                                </thead>
                                <tbody
                                    v-if="programationData[site.uuid] && programationData[site.uuid]['nbr_progra'] && programationData[site.uuid]['nbr_progra'] > 0 &&
                                        programationData[site.uuid]['nbr_progra'] <= groupInformation.article_month_generated_max">
                                    <tr v-for="n in parseInt(programationData[site.uuid]['nbr_progra'])" :key=n style=""
                                        class="mt-1">
                                        <td v-for="(elem, id) in header" style="border: solid 2px white;" class="pa-2"
                                            :key="id">
                                            <div v-if="elem.value == 'nbr'" align="center">
                                                {{ n }}
                                            </div>
                                            <div v-else-if="elem.value == 'date'" align="center" style="min-width: 300px;">
                                                <v-slider hide-details step="1" max="28" thumb-label="always"
                                                    color="white"></v-slider>
                                            </div>
                                            <div v-else-if="elem.value == 'display'" align="center">
                                                <v-card width="200px">
                                                    <v-select bg-color="white" hide-details style="width: 200px;"
                                                        label="Display"
                                                        :items="groupInformation.templates.display.filter((val) => val.platform == platform)"></v-select>
                                                </v-card>
                                            </div>
                                            <div v-else-if="elem.value == 'length'" align="center">
                                                <v-card width="200px">
                                                    <v-select bg-color="white" class="mt-2" hide-details
                                                        style="width: 200px;" label="Longueur"
                                                        :items="groupInformation.templates.length.filter((val) => val.platform == platform)"></v-select>
                                                </v-card>
                                            </div>
                                            <div v-else-if="elem.value == 'type'" align="center">
                                                <v-card width="200px">
                                                    <v-select bg-color="white" hide-details style="width: 200px;"
                                                        label="Generation type"
                                                        :items="groupInformation.templates.content.filter((val) => val.type == platform)"></v-select>
                                                </v-card>
                                            </div>
                                            <div v-else>
                                                {{ elem }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </v-card>
                </v-col>
                <v-col style="height: 64vh; overflow: auto" v-if="false && programationData[site.uuid] && programationData[site.uuid]['nbr_progra'] && programationData[site.uuid]['nbr_progra'] > 0 &&
                    programationData[site.uuid]['nbr_progra'] <= groupInformation.article_month_generated_max">
                    <v-row>
                        <v-col v-for="n in parseInt(programationData[site.uuid]['nbr_progra'])" :key=n cols="12">
                            <v-card class="pa-2 bg" variant="flat">
                                <v-col style="color: white;font-weight: bold">
                                    {{ n }} -
                                </v-col>
                                <v-card variant="solo" class="ma-1">
                                    <v-text-field label="Jour de publication du mois (conseillé entre 1 et 28)"
                                        hide-details bg-color="white">
                                    </v-text-field>
                                </v-card>
                                <v-card variant="solo" class="ma-1">
                                    <v-select bg-color="white" class="mt-2" hide-details label="Generation type"
                                        :items="groupInformation.templates.content.filter((val) => val.type == platform)"></v-select>
                                </v-card>
                                <v-card variant="solo" class="ma-1">
                                    <v-select bg-color="white" class="mt-2" hide-details label="Display"
                                        :items="groupInformation.templates.display.filter((val) => val.platform == platform)"></v-select>
                                </v-card>
                                <v-card variant="solo" class="ma-1">
                                    <v-select bg-color="white" class="mt-2" hide-details label="Longueur"
                                        :items="groupInformation.templates.length.filter((val) => val.platform == platform)"></v-select>
                                </v-card>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </div>
        </v-col>
    </v-card>
</template>

<script>
export default {
    props: {
        groupInformation: {}
    },
    data() {
        return {
            header: [
                {
                    label: '',
                    value: 'nbr',
                },
                {
                    label: 'Jour de publication du mois (conseillé entre 1 et 28)',
                    value: 'date',
                },
                {
                    label: 'Type',
                    value: 'type',
                },
                {
                    label: 'Affichage',
                    value: 'display',
                },
                {
                    label: 'Longueur',
                    value: 'length',
                },
            ],
            platformToShow: ['shopify'],
            key_words: ['test', 'test', 'test'],
            daysToPubli: [1, 28],
            programationData: {},
            articleData: {
                nbr_publication_max: 5,
                nbr_publication_auto: 2,
                nbr_publication_left: 4,
                publication_date: [5, 10]
            }
        }
    },
    mounted() {
        console.log("groupInformation", this.groupInformation);
        for (let i = 0; i < this.platformToShow.length; i++) {
            for (let a = 0; a < this.groupInformation.web_site_data[this.platformToShow[i]].length; a++) {
                let id = this.groupInformation.web_site_data[this.platformToShow[i]][a].uuid
                if (this.programationData[id] == undefined)
                    this.programationData[id] = {
                        nbr_progra: 2
                    }
            }
        }
    }
}
</script>

<style></style>